import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PostMethod } from "../../../Service/ApiCallMethod";

export const validateEmailCall = createAsyncThunk(
  "user/validateEmailCall",
  async (payload, thunkAPI) => {
    try {
      const response = await PostMethod("/chat/email/validate", payload);
      const data = await response.data;
      if (response.status != 200 && response.status != 201) {
        // Handle non-2xx HTTP responses
        return thunkAPI.rejectWithValue(data.message || "Something went wrong");
      }
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Network error");
    }
  }
);

const initialState = {
  validatedCallData: null,
  loading: false,
  error: null,
};

export const ValidateEmailCallSlice = createSlice({
  name: "validateEmailCall",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(validateEmailCall.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(validateEmailCall.fulfilled, (state, action) => {
        state.loading = false;
        state.validatedCallData = action.payload;
        state.error = null; // Clear any previous errors
      })
      .addCase(validateEmailCall.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ValidateEmailCallSlice.reducer;
